'use client'
import { notFound, redirect } from 'next/navigation'
import { memo } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { getOperatorHomePagePath } from '~/app/helpers'

import { useAuthenticatedUser } from '~/hooks/useAuthentication'

import {
  CustomerLoadBasePath,
  IntegratedTrackingBasePath,
  ShipmentBasePath,
} from '~/constants/urls'

import { CustomerType, UserRole } from '~/__generated_types__/globalTypes'

const RootPage = () => {
  const [user] = useAuthenticatedUser()
  const { showHomePageSetting, allowNewUserWorkflows } = useFlags()

  switch (user.role) {
    case UserRole.Operator:
      if (allowNewUserWorkflows) {
        redirect('/home')
      }
      showHomePageSetting
        ? redirect(getOperatorHomePagePath(user.settings.homePage))
        : redirect('/visibility')
    case UserRole.Sysadmin:
      showHomePageSetting
        ? redirect(getOperatorHomePagePath(user.settings.homePage))
        : redirect('/visibility')
    case UserRole.Customer:
      switch (user.customer?.type) {
        case CustomerType.Tm:
          redirect(ShipmentBasePath)
        case CustomerType.Dts:
          redirect(CustomerLoadBasePath)
        case CustomerType.Integrated:
          redirect(IntegratedTrackingBasePath)
      }
    default:
      notFound()
  }
}

export default memo(RootPage)
